import GetParamURL from "./GetParamURL";

const GetLastClaimedArticleFromCallback = () => {
    const callbackUrl = GetParamURL().URLCallback;
    const notaIdKey = '-nid';
    const notaIdKeyIndex = callbackUrl.indexOf(notaIdKey);

    if (notaIdKeyIndex < 0) {
        return null;
    }

    const notaUrlIndex = callbackUrl.lastIndexOf('/') + 1;
    const notaId = callbackUrl.substring(notaIdKeyIndex + notaIdKey.length, notaUrlIndex - 1);
    const notaUrl = callbackUrl.substring(0, notaUrlIndex);

    const data = {
        id: notaId,
        url: notaUrl
    };
    
    return data;

}

export default GetLastClaimedArticleFromCallback;